module.exports = __webpack_public_path__ + "media/images/bow-tie-8dbb1ce014789e0d91c52ef58bc7a625.svg";